import { Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import type { EditionDto, MagazineDto } from '../../../../api/responses'

@Component({
  selector: 'dhp-prices',
  templateUrl: './prices.component.html',
  imports: [TranslatePipe],
})
export class PricesComponent {
  readonly data = input.required<MagazineDto | EditionDto>()
  readonly hideTitle = input<boolean>(false)

  additionalSections = [
    {
      title: 'pages.prices.sections.subscriptionDurationTitle',
      content: 'pages.prices.sections.subscriptionDurationContent',
    },
  ]

  get magazine(): MagazineDto {
    const data = this.data()
    if ('tags' in data) return data
    else return (data as EditionDto).magazine
  }

  // Textual description of package pricing
  protected getDigitalPackageDescription(): string {
    const description = this.magazine.pricing?.match(
      /digitaal informatiepakket:.*?(?=\s*(?:De tijdschriften|<\/p>))/is
    )?.[0]
    return (
      description
        ?.replace(/<[^>]*>/g, '')
        .replace(/€\s*\d+/, '')
        .replace(/^[^:]*:/, '')
        .trim() ?? ''
    )
  }
  protected formatPrice(price: number | string | null): string {
    if (!price) return '-'
    const numericPrice = typeof price === 'string' ? parseFloat(price) : price
    return `€ ${numericPrice.toFixed(2)}`
  }
}
